module.exports = __webpack_public_path__ + "static/Travel-ae4af709c194804dfc35e1585428532c.svg";